export const setCookie = (cookieName: string, cookieValue: string, expirationMin: number) => {
    const expirationTime = new Date(Date.now() + expirationMin * 60 * 1000); 
    const cookieString = `${cookieName}=${cookieValue}; expires=${expirationTime.toUTCString()}; path=/`;
    document.cookie = cookieString;
}

export const getCookieValue = (cookieName: string) => {
    const allCookies = document.cookie;
    const cookiesList = allCookies.split('; ');

    for (const cookie of cookiesList) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
            return value;
        }
    }

    return null;
}